export default "__VITE_ASSET__DETTG_4E__"